import {safeHtml} from "../../js/util/CommonUtils.js";

export default class StructurePopupHtml {
    /** @type {HTMLElement}*/
    #popupElement;
    /** @type {HTMLElement}*/
    #hoverElement;
    /** @type {number} */
    #height = 350;
    /** @type {number} */
    #width = 400;

    /**
     * @param {HTMLElement} hoverElement
     */
    init(hoverElement) {
        this.#hoverElement = hoverElement;
    }

    /**
     * @param {string} svgLink
     */
    show(svgLink) {
        this.#hoverElement.parentElement.insertAdjacentHTML('beforeend', this.#template(svgLink));
        this.#popupElement = this.#hoverElement.parentElement.lastElementChild;
        // calculate & set the position
        const verticalPosition = this.#calcVerticalPositionOfStructurePopup(this.#hoverElement);
        const horizPosition = this.#hoverElement.offsetLeft + this.#hoverElement.offsetWidth + 5;
        this.#popupElement.style.top = verticalPosition + "px";
        this.#popupElement.style.left = horizPosition + "px";
    }

    remove() {
        this.#popupElement.remove();
    }

    /**
     * @param {string} svgLink
     */
    #template(svgLink) {
        return safeHtml`
        <div class="structure-popup">
            <img src="${svgLink}" alt="chemical structure" width="${this.#width}" height="${this.#height}" />
        </div>
        `;
    }

    /**
     * @param {HTMLElement} hoverElement
     * @returns {number}
     */
    #calcVerticalPositionOfStructurePopup(hoverElement) {
        /** @type {DOMRect} */
        const hoverElementRect = this.#hoverElement.getBoundingClientRect()
        const vh = document.documentElement.clientHeight;// height of the viewport w/o the scroll
        const maxVerticalPosition = vh - this.#height;
        // "perfect" is in the middle (vertically) of the element that we're hovering over
        const perfectVerticalPosition = (hoverElementRect.bottom + hoverElementRect.top) / 2 - this.#height / 2;
        // If the hover over element is at the bottom of the page, then if we show the popup in the middle of it,
        // it'll go beyond the page. So in that case we actually want to step away from the "perfect". So if
        // perfectPosition > maxPosition, then the diff is negative, and we add that diff to the perfect position.
        const offsetBetweenPerfectAndMax = Math.min(0, maxVerticalPosition - perfectVerticalPosition);
        // we don't want to go beyond the top of the screen either
        const offsetBetweenPerfectAndMin = Math.max(0, -perfectVerticalPosition);
        const clampedOffset = offsetBetweenPerfectAndMax + offsetBetweenPerfectAndMin;//only one can be non-zero
        // But the eventual coordinates aren't relative to the viewport - but to some parent of the hover element,
        // so we need to take the offsetTop instead of viewport-relative coordinates.
        return hoverElement.offsetTop + clampedOffset - this.#height/2;
    }

}